import { render } from "./TitleTabletFormComponentDetails.vue?vue&type=template&id=3eb6b7e1"
import script from "./TitleTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./TitleTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__